import React from "react";
import { object, array, bool, number, string } from "prop-types";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import "./story-card2.m.css";

const StoryCard2 = ({ story, aspectRatio, imageType, headerType, showAuthorName, id, showRedDot, headerLevel }) => {
  return (
    <div className="story-card story-card-2" styleName="story-card-2" id="story-card-2">
      <Link href={`/${story.slug}`}>
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          showAuthorName={showAuthorName}
          showStoryTypeIcon
          showVideoIcon
          widths={[400]}
        />
      </Link>

      <Link href={`/${story.slug}`} className="headline-link">
        <Headline
          text={story.headline}
          headerType={headerType}
          headerLevel={headerLevel}
          story={story}
          width={20}
          height={20}
          id={id}
          showRedDot={showRedDot}
        />
      </Link>
    </div>
  );
};

StoryCard2.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 2,
  headerLevel: 2,
  showAuthorName: false,
  showSummary: true,
  isExternalStory: false,
  showRedDot: false
};

StoryCard2.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  showAuthorName: bool,
  showSummary: bool,
  id: string,
  isExternalStory: bool,
  pageType: string,
  showRedDot: bool
};

export default StoryCard2;
